<template>
<section v-if="contact">
  <div style="background: white; padding:5px">
    <b-field grouped group-multiline>
      <b-field>
        <span class="panel-icon" style="font-size:1.3em;">
            <!-- TODO  -->
            <i v-if="contact.status.custclass === 4" class="fas fa-trophy" style="color: gold;" aria-hidden="true"></i>
            <i v-if="contact.status.custclass === 3" class="fas fa-trophy" style="color: silver;" aria-hidden="true"></i>
            <i v-if="contact.status.custclass === 2" class="fas fa-trophy" style="color: orange;" aria-hidden="true"></i>
            <i v-if="contact.status.custclass === 1" class="fas fa-trophy" style="color: black;" aria-hidden="true"></i>
          </span>
      </b-field>
      <b-field>
        <!-- {{contact.firstname}} {{contact.name}} -->
        {{contact.displayName}}
      </b-field>

      <!-- <b-field  style="margin-left: 3em;">
        <span><b>{{contact.revenue}}</b></span>
      </b-field>
      <b-field>
        <b-field grouped class="panel-icon" style="margin-left: 3em;">
          <i v-if="contact.channels.includes('phone')" class="fas fa-phone" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
          <i v-if="contact.channels.includes('email')" class="fas fa-envelope" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
          <i v-if="contact.channels.includes('facebook')" class="fab fa-facebook" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
          <i v-if="contact.channels.includes('skype')" class="fab fa-skype" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
        </b-field>
      </b-field> -->
    </b-field>  

  </div>
    
</section>
</template>

<script>

export default {

  name: 'ListPanelItem',
  components: {
    
  },
  // data() {
  //   return  {
  //   }
  // },
  props: {
    contact: {},
  },
  computed: {
    // isRead: this.contact.status==='read' ? true: false
  },
  methods: {
    // isread (status) {
    //   if (status==='read') return true;
    //   return false;
    // }
    // clickMe () {
    //   window.alert(this.msg)
    // }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .read {
    background: green;
  } */
</style>